import { render, staticRenderFns } from "./RenamableProperty.vue?vue&type=template&id=50fbd6aa&scoped=true&"
import script from "./RenamableProperty.vue?vue&type=script&lang=js&"
export * from "./RenamableProperty.vue?vue&type=script&lang=js&"
import style0 from "./RenamableProperty.vue?vue&type=style&index=0&id=50fbd6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbd6aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fbd6aa')) {
      api.createRecord('50fbd6aa', component.options)
    } else {
      api.reload('50fbd6aa', component.options)
    }
    module.hot.accept("./RenamableProperty.vue?vue&type=template&id=50fbd6aa&scoped=true&", function () {
      api.rerender('50fbd6aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/RenamableProperty.vue"
export default component.exports